import React, { useEffect, useState } from "react";
import "./App.css";

const COUNTRY_DATA = {
  US: {
    label: "🇺🇸 Big Brother USA",
    title: "Big Brother USA Vote",
    strawpollUrl: "https://strawpoll.com/embed/USA_POLL", // replace later
    officialVoteUrl: "https://www.cbs.com/shows/big_brother/",
    contestants: [
      {
        id: "matt",
        name: "Matt",
        img: "https://via.placeholder.com/300",
        info: "Strong competitor and social player.",
        phone: null
      },
      {
        id: "jag",
        name: "Jag",
        img: "https://via.placeholder.com/300",
        info: "Strategic thinker with alliances.",
        phone: null
      }
    ]
  },

  ES: {
    label: "🇪🇸 Gran Hermano (Spain)",
    title: "Gran Hermano Votación",
    strawpollUrl: "https://strawpoll.com/embed/SPAIN_POLL", // replace later
    officialVoteUrl: "https://www.telecinco.es/granhermano/",
    contestants: [
      {
        id: "carlos",
        name: "Carlos",
        img: "https://via.placeholder.com/300",
        info: "Carismático y competitivo.",
        phone: null
      },
      {
        id: "lucia",
        name: "Lucía",
        img: "https://via.placeholder.com/300",
        info: "Inteligente y observadora.",
        phone: null
      }
    ]
  },

  BR: {
    label: "🇧🇷 Big Brother Brasil",
    title: "Big Brother Brasil Votação",
    strawpollUrl: "https://strawpoll.com/embed/GPgVYWY6pna", // replace later
    officialVoteUrl: "https://gshow.globo.com/realities/bbb/",
    contestants: [
      {
        id: "Alberto",
        name: "Alberto",
        img: "https://cdn.strawpoll.com/images/polls/options/w4nWqOk3ZAL-c.png",
        info: "Popular",
        phone: null
      },
      {
        id: "AnaPaula",
        name: "Ana Paula",
        img: "https://cdn.strawpoll.com/images/polls/options/xVg7bD9KnrR-c.png",
        info: "Jogador estratégico.",
        phone: null
      },
      {
        id: "Babu",
        name: "Babu",
        img: "https://cdn.strawpoll.com/images/polls/options/3RnYRJzQgeA-c.png",
        info: "Popular",
        phone: null
      },
      {
        id: "Breno",
        name: "Breno",
        img: "https://cdn.strawpoll.com/images/polls/options/QrgeM45OgpY-c.png",
        info: "Popular",
        phone: null
      },
      {
        id: "Brigido",
        name: "Brigido",
        img: "https://cdn.strawpoll.com/images/polls/options/PKgl9OxaZp0-c.png",
        info: "Popular",
        phone: null
      },
      {
        id: "Chaiany",
        name: "Chaiany",
        img: "https://cdn.strawpoll.com/images/polls/options/XOgOqLxXy3o-c.png",
        info: "Popular",
        phone: null
      },
      {
        id: "Edílson",
        name: "Edílson",
        img: "https://cdn.strawpoll.com/images/polls/options/ajnEqMj0nWV-c.png",
        info: "Popular",
        phone: null
      },
      {
        id: "Gabriela",
        name: "Gabriela",
        img: "https://cdn.strawpoll.com/images/polls/options/e7ZJqrovg3K-c.png",
        info: "Popular",
        phone: null
      },
      {
        id: "Jonas",
        name: "Jonas",
        img: "https://cdn.strawpoll.com/images/polls/options/7rnzk47YgOl-c.png",
        info: "Popular",
        phone: null
      },
      {
        id: "Jordana",
        name: "Jordana",
        img: "https://cdn.strawpoll.com/images/polls/options/e6Z2b9xMZNG-c.png",
        info: "Popular",
        phone: null
      },
      {
        id: "Juliano",
        name: "Juliano",
        img: "https://cdn.strawpoll.com/images/polls/options/w4nWqOkJZAL-c.png",
        info: "Popular",
        phone: null
      },
      {
        id: "Leandro",
        name: "Leandro",
        img: "https://cdn.strawpoll.com/images/polls/options/xVg7bD8RnrR-c.png",
        info: "Popular",
        phone: null
      },
      {
        id: "Marcelo",
        name: "Alberto",
        img: "https://cdn.strawpoll.com/images/polls/options/3RnYRJEpgeA-c.png",
        info: "Popular",
        phone: null
      },
      {
        id: "Marciele",
        name: "Marciele",
        img: "https://cdn.strawpoll.com/images/polls/options/PKgl9OveZp0-c.png",
        info: "Popular",
        phone: null
      },
      {
        id: "Maxiane",
        name: "Maxiane",
        img: "https://cdn.strawpoll.com/images/polls/options/Q0ZpMz36yMB-c.png",
        info: "Popular",
        phone: null
      },
      {
        id: "Milena",
        name: "Milena",
        img: "https://cdn.strawpoll.com/images/polls/options/kogjVNoqg6M-c.png",
        info: "Popular",
        phone: null
      },
      {
        id: "Samira",
        name: "Samira",
        img: "https://cdn.strawpoll.com/images/polls/options/ajnEqdOBnWV-c.png",
        info: "Popular",
        phone: null
      },
      {
        id: "Sarah",
        name: "Sarah",
        img: "https://cdn.strawpoll.com/images/polls/options/e7ZJqdGKg3K-c.png",
        info: "Popular",
        phone: null
      },
      {
        id: "Sol",
        name: "Sol",
        img: "https://cdn.strawpoll.com/images/polls/options/40ZmM0q2ZaR-c.png",
        info: "Popular",
        phone: null
      },
      {
        id: "Solange",
        name: "Solange",
        img: "https://cdn.strawpoll.com/images/polls/options/7rnzkrmagOl-c.png",
        info: "Popular",
        phone: null
      },
    ]
  },

  UK: {
    label: "🇬🇧 Big Brother UK",
    title: "Big Brother UK Vote",
    strawpollUrl: "https://strawpoll.com/embed/UK_POLL", // replace later
    officialVoteUrl: "https://www.itv.com/watch/big-brother",
    contestants: [
      {
        id: "emma",
        name: "Emma",
        img: "https://via.placeholder.com/300",
        info: "Outspoken and bold.",
        phone: null
      },
      {
        id: "tom",
        name: "Tom",
        img: "https://via.placeholder.com/300",
        info: "Quiet but observant.",
        phone: null
      }
    ]
  },

  AU: {
    label: "🇦🇺 Big Brother Australia",
    title: "Big Brother Australia Vote",
    strawpollUrl: "https://strawpoll.com/embed/AU_POLL", // replace later
    officialVoteUrl: "https://10play.com.au/big-brother",
    contestants: [
      {
        id: "dan",
        name: "Dan",
        img: "https://via.placeholder.com/300",
        info: "Physical powerhouse.",
        phone: null
      },
      {
        id: "sarah",
        name: "Sarah",
        img: "https://via.placeholder.com/300",
        info: "Socially strong player.",
        phone: null
      }
    ]
  },

  CA: {
    label: "🇨🇦 Big Brother Canada",
    title: "Big Brother Canada Vote",
    strawpollUrl: "https://strawpoll.com/embed/CA_POLL", // replace later
    officialVoteUrl: "https://www.bigbrothercanada.ca/",
    contestants: [
      {
        id: "ty",
        name: "Ty",
        img: "https://via.placeholder.com/300",
        info: "Aggressive strategist.",
        phone: null
      },
      {
        id: "claudia",
        name: "Claudia",
        img: "https://via.placeholder.com/300",
        info: "Fan favorite.",
        phone: null
      }
    ]
  },

  NG: {
    label: "🇳🇬 Big Brother Naija",
    title: "Big Brother Naija Vote",
    strawpollUrl: "https://strawpoll.com/embed/NG_POLL", // replace later
    officialVoteUrl: "https://www.africamagic.tv/bigbrothernaija",
    contestants: [
      {
        id: "mercy",
        name: "Mercy",
        img: "https://via.placeholder.com/300",
        info: "Bold and dramatic.",
        phone: null
      },
      {
        id: "tacha",
        name: "Tacha",
        img: "https://via.placeholder.com/300",
        info: "Strong personality.",
        phone: null
      }
    ]
  },

  ZA: {
    label: "🇿🇦 Big Brother Mzansi",
    title: "Big Brother Mzansi Vote",
    strawpollUrl: "https://strawpoll.com/embed/w4nWW7rRqnA", // replace later
    officialVoteUrl: "https://www.dstv.com/mzansimagic/en-za/show/big-brother-mzansi",
    contestants: [
      {
        id: "TumitheBarber",
        name: "Tumi the Barber",
        img: "https://cdn.strawpoll.com/images/polls/options/XmZRkdmWydb-c.png",
        info: "Barber and dancer",
        phone: null
      },
      {
        id: "Ashay",
        name: "Ashay",
        img: "https://cdn.strawpoll.com/images/polls/options/GeZAbxAkyV5-c.png",
        info: "Personal trainer and content creator",
        phone: null
      },
      {
        id: "BravoB",
        name: "Bravo B",
        img: "https://cdn.strawpoll.com/images/polls/options/7MZ0b3j1nom-c.png",
        info: "Food vendor",
        phone: null
      },
      {
        id: "BuhleB",
        name: "Buhle B",
        img: "https://cdn.strawpoll.com/images/polls/options/2ayLLMdvy4k-c.png",
        info: "Recent graduate",
        phone: null
      },
      {
        id: "DeneJones",
        name: "Dene Jones",
        img: "https://cdn.strawpoll.com/images/polls/options/LVyKqMdQg04-c.png",
        info: "Legal officer, content creator, and student",
        phone: null
      },
      {
        id: "Didi",
        name: "Didi",
        img: "https://cdn.strawpoll.com/images/polls/options/X3nkLvbjgEP-c.png",
        info: "Student",
        phone: null
      },
      {
        id: "Dube",
        name: "Dube",
        img: "https://cdn.strawpoll.com/images/polls/options/XOgOqLOGy3o-c.png",
        info: "Telesales agent",
        phone: null
      },
      {
        id: "Ilano",
        name: "Ilano",
        img: "https://cdn.strawpoll.com/images/polls/options/ajnEqMdBnWV-c.png",
        info: "Club promoter",
        phone: null
      },
      {
        id: "KingWanda",
        name: "King Wanda",
        img: "https://cdn.strawpoll.com/images/polls/options/e7ZJqrdKg3K-c.png",
        info: "Municipality employee",
        phone: null
      },
      {
        id: "Kokii",
        name: "Kokii",
        img: "https://cdn.strawpoll.com/images/polls/options/40ZmME02ZaR-c.png",
        info: "Carltonville",
        phone: null
      },
      {
        id: "Liema",
        name: "Liema",
        img: "https://cdn.strawpoll.com/images/polls/options/7rnzk4ragOl-c.png",
        info: "Musician",
        phone: null
      },
      {
        id: "Mashel",
        name: "Mashel",
        img: "https://cdn.strawpoll.com/images/polls/options/e2na6eoAgBO-c.png",
        info: "Ex-radio personality",
        phone: null
      },
      {
        id: "Mmeli",
        name: "Mmeli",
        img: "https://cdn.strawpoll.com/images/polls/options/e6Z2b9wXZNG-c.png",
        info: "Content creator and model",
        phone: null
      },
      {
        id: "Mshefane",
        name: "Mshefane",
        img: "https://cdn.strawpoll.com/images/polls/options/w4nWqO7QZAL-c.png",
        info: "Content creator",
        phone: null
      },
      {
        id: "Neliswa",
        name: "Neliswa",
        img: "https://cdn.strawpoll.com/images/polls/options/xVg7bDvGnrR-c.png",
        info: "Club entertainment manager",
        phone: null
      },
      {
        id: "Que",
        name: "Que",
        img: "https://cdn.strawpoll.com/images/polls/options/3RnYRJeWgeA-c.png",
        info: "Corporate fleet analyst",
        phone: null
      },
      {
        id: "Ramona",
        name: "Ramona",
        img: "https://cdn.strawpoll.com/images/polls/options/QrgeM4rXgpY-c.png",
        info: "Montagu",
        phone: null
      },
      {
        id: "Thandeka",
        name: "Thandeka",
        img: "https://cdn.strawpoll.com/images/polls/options/PKgl9OKEZp0-c.png",
        info: "Bookkeeper",
        phone: null
      },
      {
        id: "The Don",
        name: "The Don",
        img: "https://cdn.strawpoll.com/images/polls/options/XOgOqLqay3o-c.png",
        info: "Commercial model and content creator",
        phone: null
      },
      {
        id: "Trixie",
        name: "Trixie",
        img: "https://cdn.strawpoll.com/images/polls/options/ajnEqMqNnWV-c.png",
        info: "Club promoter",
        phone: null
      }
    ]
  },

  AR: {
    label: "🇦🇷 Gran Hermano Argentina",
    title: "Gran Hermano Argentina Votación",
    strawpollUrl: "https://strawpoll.com/embed/AR_POLL", // replace later
    officialVoteUrl: "https://mitelefe.com/gran-hermano/",
    contestants: [
      {
        id: "julian",
        name: "Julian",
        img: "https://via.placeholder.com/300",
        info: "Muy competitivo.",
        phone: null
      },
      {
        id: "romina",
        name: "Romina",
        img: "https://via.placeholder.com/300",
        info: "Carismática.",
        phone: null
      }
    ]
  },

  PH: {
    label: "🇵🇭 Pinoy Big Brother",
    title: "Pinoy Big Brother Vote",
    strawpollUrl: "https://strawpoll.com/embed/PH_POLL", // replace later
    officialVoteUrl: "https://ent.abs-cbn.com/pinoybigbrother",
    contestants: [
      {
        id: "kai",
        name: "Kai",
        img: "https://via.placeholder.com/300",
        info: "Energetic and friendly.",
        phone: null
      },
      {
        id: "mika",
        name: "Mika",
        img: "https://via.placeholder.com/300",
        info: "Smart and calm.",
        phone: null
      }
    ]
  }
};

function detectCountryAuto() {
  // 1️⃣ User override always wins
  const override = localStorage.getItem("country_override");
  if (override && COUNTRY_DATA[override]) return override;

  // 2️⃣ Domain-based detection
  const host = window.location.hostname.toLowerCase();

  if (host.includes("usa") || host.includes("bigbrotherusa")) return "US";
  if (host.includes("spain") || host.includes("bigbrotherspain")) return "ES";
  if (host.includes("brazil") || host.includes("brasil") || host.includes("bigbrotherbrazil")) return "BR";
  if (host.includes("uk") || host.includes("bigbrotheruk")) return "UK";
  if (host.includes("australia") || host.includes("bigbrotheraustralia")) return "AU";
  if (host.includes("canada") || host.includes("bigbrothercanada")) return "CA";
  if (host.includes("nigeria") || host.includes("bigbrothernigeria")) return "NG";
  if (host.includes("southafrica") || host.includes("bigbrothermzansi")) return "ZA";
  if (host.includes("argentina") || host.includes("bigbrotherargentina")) return "AR";
  if (host.includes("philippines") || host.includes("bigbrotherphilippines")) return "PH";

  // 3️⃣ Cloudflare IP country
  if (window.__CF_COUNTRY__ && COUNTRY_DATA[window.__CF_COUNTRY__]) {
    return window.__CF_COUNTRY__;
  }

  // 4️⃣ Browser language heuristic
  const lang = navigator.language?.toLowerCase() || "";
  if (lang.startsWith("pt")) return "BR";
  if (lang.startsWith("es")) return "ES";
  if (lang.startsWith("en-gb")) return "UK";
  if (lang.startsWith("en-au")) return "AU";
  if (lang.startsWith("en-ca")) return "CA";
  if (lang.startsWith("tl")) return "PH";

  // 5️⃣ Safe default
  return "US";
}


export default function App() {
  const [country, setCountry] = useState(detectCountryAuto());

  useEffect(() => {
    localStorage.setItem("country_override", country);
  }, [country]);

  const data = COUNTRY_DATA[country];

  return (
    <div className="site">
      <header className="hero">
        <div className="hero-inner">
          <h1>{data.title}</h1>
          <p className="lead">
            Be the change you want to see on the show. Vote for your favorite contestant and help them stay in the game!
          </p>

          <div style={{ marginTop: 12, marginBottom: 20 }}>
            <select value={country} onChange={(e) => setCountry(e.target.value)}>
              {Object.entries(COUNTRY_DATA).map(([code, c]) => (
                <option key={code} value={code}>{c.label}</option>
              ))}
            </select>
          </div>

          <div className="hero-ctas">
            <a className="btn primary sparkle" href="#poll">Vote Now</a>
            <a className="btn secondary sparkle" href="#contestants">See Contestants</a>
          </div>
        </div>
      </header>

      <main className="container">

        {/* INTRO — unchanged */}
        <section className="intro">
          <h2>What is Big Brother?</h2>
          <p>
            Big Brother is one of the most popular reality TV formats worldwide,
            where contestants live together under constant surveillance.
          </p>
        </section>

        {/* POLL — country based */}
        <section id="poll" className="poll-embed" style={{ marginTop: '80px' }}>
          <h1 className="pulse" style={{ textAlign: 'center', color: "red" }}>
            Live Poll
          </h1>
          <div className="embed-wrap">
            <iframe
              title="strawpoll"
              src={data.strawpollUrl}
              frameBorder="0"
              sandbox="allow-scripts allow-same-origin allow-forms"
            />
          </div>
        </section>

        {/* CONTESTANTS — same layout */}
        <section id="contestants" className="contestants" style={{ marginTop: '100px' }}>
          <h2>Contestants</h2>

          <div className="grid">
            {data.contestants.map(c => (
              <article key={c.id} className="card">
                <div className="thumb">
                  <img src={c.img} alt={c.name} />
                </div>
                <div className="card-body">
                  <h3>{c.name}</h3>
                  <p className="bio">{c.info}</p>

                  <div style={{ marginTop: 8, display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                    {/* 🔁 Official site instead of Hotstar */}
                    <a
                      className="btn small sparkle"
                      href={data.officialVoteUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Vote on Official Site
                    </a>

                    {c.phone && (
                      <a
                        className="btn small tertiary sparkle"
                        href={`tel:${c.phone}`}
                      >
                        📞 Vote via Call
                      </a>
                    )}
                  </div>
                </div>
              </article>
            ))}
          </div>
        </section>

      </main>

      <footer className="footer">
        <div className="container">
          <p>© {new Date().getFullYear()} ZINZER - All Rights Reserved.</p>
          <small>
            Disclaimer: This is a fan-made website and is not affiliated with any official broadcaster.
          </small>
        </div>
      </footer>
    </div>
  );
}
